export const useCheckingValue = (value: string): string => value ?? "-";
